import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import { MdArrowBackIosNew } from "react-icons/md";

const Footer = () => {
  const navigate = useNavigate();
  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down
        setShowFooter(false);
      } else {
        // Scrolling up
        setShowFooter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleHome = () => {
    navigate("/betamountpage"); // or your home route
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      {/* 🔻 Bottom Fixed Navigation */}
      <div
        style={{
          // background: "#0e3e3d",
          //  transition: "transform 0.3s ease-in-out",
          transform: showFooter ? "translateY(0)" : "translateY(100%)",
        }}
        className="block md:hidden fixed bottom-0 left-0 right-0 flex flex-wrap justify-between gap-6 items-center mx-auto px-6 py-2 z-40 bg-gradient-to-l from-cyan-950 via-cyan-800 to-cyan-950"
      >
        <button
          onClick={handleHome}
          className="flex flex-col items-center gap-1 hover:text-green-400 transition"
        >
          <FiHome size={20} />
        </button>
        {/* Back */}
        <button
          onClick={handleBack}
          className="flex flex-col items-center gap-1 hover:text-red-400 transition"
        >
          <MdArrowBackIosNew size={20} />
        </button>
      </div>
    </>
  );
};

export default Footer;
